<template>
	<el-dialog :visible.sync="showdswin" title="平台信息" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="true">
		<table class="basetable">
			<tr>
				<td style="80px"><span>所属平台</span></td>
				<td>
					<el-select :disabled="isedit" size="mini" v-model="form.ds_sys" @change="dtypechange" placeholder="请选择所属平台">
						<el-option v-for="(item, index) in typelist" :label="item.ds_sys" :value="item.ds_sys" :key="index"></el-option>
					</el-select>
				</td>
			</tr>
			<tr v-for="(item, index) in typeformat" :key="index" v-if="item.isshow||item.isshow==undefined">
				<td style="width:100px">
					<span>{{ item.title }}</span>
				</td>
				<td>
					<el-input size="mini" v-model="item.value" v-if="item.controltype == 'text'" :disabled="item.isedit == '0'"></el-input>
					<el-input size="mini" v-model="item.value" v-if="item.controltype == 'textarea'" type="textarea" :rows="5"></el-input>
					<el-select size="mini" v-model="item.value" v-if="item.controltype == 'select'">
						<el-option v-for="(option, idx) in item.options" :label="option.name" :value="option.value" :key="idx"></el-option>
					</el-select>
					<br />
					<span class="tips" v-if="item.remark != ''">{{ item.remark }}</span>
				</td>
			</tr>
		</table>

		<span slot="footer" class="dialog-footer">
			<div style="text-align: center;width:100%">
				<el-button size="mini" type="success" :disabled="btndisabled" @click.native="SaveDs">保存</el-button>
				<el-button size="mini" type="info" plain @click.native="showdswin = false">取消</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			form: {
				id: '',
				ds_code: '',
				ds_name: '',
				ds_domain: '',
				u_userid: '',
				dxpid: '',
				ds_register: '',
				ds_type: '',
				ds_sys: '',
				ds_comtype:''
			},
			typelist: [
				// {
				// 	ds_sys: '淘宝',
				// 	ds_type: '推送物流',
				// 	typeformat: [
				// 		{ title: '店铺名称', controltype: 'text', value: '', colname: 'ds_name', remark: '', isnull: false },
				// 		{ title: '店铺ID', controltype: 'text', value: '', colname: 'ds_code', remark: '', isnull: false },
				// 		{ title: 'Session', controltype: 'textarea', value: '', colname: 'dxpid', remark: '', isnull: false }
				// 	]
				// },
				// {
				// 	ds_sys: '中通国际',
				// 	ds_type: '推送物流',
				// 	typeformat: [{ title: '名称', controltype: 'text', value: '', colname: 'ds_name', remark: '', isnull: false },
				// 		{ title: 'clientSource', controltype: 'text', value: '', colname: 'ds_code', remark: '', isnull: false },
				// 		{ title: 'KEY', controltype: 'text', value: '', colname: 'dxpid', remark: '', isnull: false }
				// 	]
				// },
				// {
				// 	ds_sys: '韵达国际',
				// 	ds_type: '推送物流',
					// typeformat: [{ title: '名称', controltype: 'text', value: '', colname: 'ds_name', remark: '', isnull: false },
					// 	{ title: '接口账号', controltype: 'text', value: '', colname: 'ds_code', remark: '', isnull: false },
					// 	{ title: '接口密码', controltype: 'text', value: '', colname: 'dxpid', remark: '', isnull: false }
					// ]
				// }
			],
			typeformat: [],
			showdswin: false,
			id: '',
			isedit: false,
			btndisabled:false,
			divclass:'basetable'
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/baseinfo/baseinfo.scss');
		});
	},
	methods: {
		init(param) {
			this.showdswin = true;
			this.isedit = false;
			this.form = {
				id: '',
				ds_code: '',
				ds_name: '',
				ds_domain: '',
				u_userid: '',
				dxpid: '',
				ds_register: '',
				ds_type: '',
				ds_sys: '',
				ds_comtype:''
			};
			this.id='';
			this.typeformat=[];
			
			if (param.id != undefined) this.id = param.id;
			this.GetLayOut();
		},
		GetLayOut(){
			var that=this;
			this.$tool.loading('正在加载', this.divclass);
			debugger
			this.$apipost.get.GetDsFormat().then(res => {
				debugger
				this.$tool.loadingclose();
				if(res!=''){
					if(res.list.length>0){
						var list=[];
						res.list.forEach(e=>{
							list.push({ds_sys:e.ds_sys,ds_type:e.ds_type,typeformat:JSON.parse(e.typeformat)});
						})
						that.typelist=list;
						if (that.id != '') {
							that.isedit = true;
							that.loadDsInfo();
						}
						else{
							that.typeformat = JSON.parse(JSON.stringify(that.typelist[0].typeformat));
							that.form.ds_sys=JSON.parse(JSON.stringify(that.typelist[0])).ds_sys;
							that.form.ds_type=JSON.parse(JSON.stringify(that.typelist[0])).ds_type;
						}
					}
				}
			});
		},
		loadDsInfo() {
			if (this.id != '') {
				var that = this;
				this.$apipost.get.GetDsInfo({ id: this.id }).then(res => {
					if (res.state == '1') {
						that.form = res.info;
						var typeformat = that.typelist.filter(function(e) {
							return that.form.ds_sys == e.ds_sys && that.form.ds_type == e.ds_type;
						});
						if (typeformat.length > 0) {
							typeformat[0].typeformat.forEach(e => {
								for (var key in that.form) {
									if (e.colname == key) {
										e.value = that.form[key];
										break;
									}
								}
							});
						}
						that.typeformat = typeformat[0].typeformat;
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			}
		},
		dtypechange(changevalue) {
			var list = this.typelist.filter(function(e) {
				return e.ds_sys.toLowerCase().indexOf(changevalue.toLowerCase()) > -1;
			});
			if (list.length > 0) {
				this.typeformat =list[0].typeformat;// JSON.parse(JSON.stringify(list[0].typeformat));
				this.form.ds_type = list[0].ds_type;
				this.form.ds_sys = list[0].ds_sys;
			}
		},
		//保存平台信息
		SaveDs() {
			var that = this;
			if (this.typeformat.length == 0) {
				this.$tool.message('请选择所属平台', 0);
				return false;
			}
			var isgo = true;
			this.typeformat.forEach(e => {
				if (!e.isnull) {
					if (e.value == '') {
						this.$tool.message('请填写' + e.title, 0);
						isgo = false;
						return false;
					}
				}
			});
			if (isgo) {
				var paraminfo = {
					id: this.form.id,
					ds_sys: this.form.ds_sys,
					ds_type: this.form.ds_type,
					u_userid: localStorage.getItem('userid'),
					typeformat: this.typeformat
				};
				var that = this;
				 // console.log('店铺', encodeURIComponent(JSON.stringify(paraminfo)));
				 // debugger;
				this.btndisabled=true;
				this.$tool.loading('正在保存', this.divclass);
				this.$apipost.post.SaveDsInfo({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					this.btndisabled=false;
					if (res.state == '1') {
						this.$tool.message('保存成功', 1);
						this.showdswin = false;
						that.$parent.refreshgrid(true);
					} else {
						this.$tool.message(res.message, 0);
					}
				});
			}
		}
	}
};
</script>

<style></style>
